// Mock data for Thaklis Finance System
// This represents the complete financial picture for Thaklis

import moment from 'moment';

// ========================================
// THAKLIS FINANCIAL OVERVIEW
// ========================================

export const thaklisFinanceOverview = {
  // Current month financial summary
  currentMonth: {
    totalRevenue: 125450.00,          // Total collected from customers
    totalCosts: 98360.00,              // Paid to service partners
    grossProfit: 27090.00,             // Revenue - Costs
    totalCommissions: 5418.00,         // Paid to channel partners
    netProfit: 21672.00,               // Gross Profit - Commissions

    // Breakdown by type
    ticketRevenue: 108950.00,
    topupFees: 16500.00,

    // Pending amounts
    pendingServicePartnerPayments: 12450.00,
    pendingChannelPartnerCommissions: 2150.00,
  },

  // Last 6 months trend
  monthlyTrend: [
    { month: moment().subtract(5, 'months').format('MMM YYYY'), revenue: 98000, grossProfit: 19600, netProfit: 15680 },
    { month: moment().subtract(4, 'months').format('MMM YYYY'), revenue: 105000, grossProfit: 21000, netProfit: 16800 },
    { month: moment().subtract(3, 'months').format('MMM YYYY'), revenue: 112000, grossProfit: 22400, netProfit: 17920 },
    { month: moment().subtract(2, 'months').format('MMM YYYY'), revenue: 118000, grossProfit: 23600, netProfit: 18880 },
    { month: moment().subtract(1, 'months').format('MMM YYYY'), revenue: 121000, grossProfit: 24200, netProfit: 19360 },
    { month: moment().format('MMM YYYY'), revenue: 125450, grossProfit: 27090, netProfit: 21672 },
  ],

  // Wallet balances
  walletBalances: {
    thaklis: 45680.00,                 // Thaklis main wallet balance
    totalCustomerWallets: 128450.00,   // Sum of all customer wallets
    totalPartnerWallets: 34560.00,     // Sum of all partner wallets
  }
};

// ========================================
// DETAILED TRANSACTIONS (Enhanced)
// ========================================

export const detailedTransactions = [
  // Customer Topup
  {
    id: 'txn-001',
    date: moment().subtract(2, 'days').toISOString(),
    type: 'TOPUP',
    subType: 'GATEWAY_PAYMENT',
    amount: 5000.00,
    currency: 'AED',
    status: 'COMPLETED',

    // Parties involved
    from: { id: 'cust-001', name: 'ABC Corporation', type: 'CUSTOMER' },
    to: { id: 'thaklis', name: 'Thaklis', type: 'THAKLIS' },

    // Payment details
    paymentMethod: 'Stripe',
    gatewayFee: 146.00,
    netAmount: 4854.00,
    reference: 'ch_3OqXXXXXXXXXXXXX',

    // Balance tracking
    openingBalance: 12000.00,
    closingBalance: 17000.00,
  },

  // Customer pays for ticket
  {
    id: 'txn-002',
    date: moment().subtract(1, 'days').toISOString(),
    type: 'TICKET_PAYMENT',
    subType: 'CUSTOMER_TO_THAKLIS',
    amount: 1250.00,
    currency: 'AED',
    status: 'COMPLETED',

    // Parties involved
    from: { id: 'cust-001', name: 'ABC Corporation', type: 'CUSTOMER' },
    to: { id: 'thaklis', name: 'Thaklis', type: 'THAKLIS' },

    // Ticket details
    ticketId: 'TKT-12345',
    ticketNumber: 'ORG-ABC-001',
    serviceName: 'Visa Renewal',
    servicePartner: { id: 'partner-001', name: 'Emirates Services LLC' },
    channelPartner: { id: 'cp-001', name: 'Elite Business Consultants' },

    // Financial breakdown
    customerCharge: 1250.00,
    partnerCost: 1050.00,
    grossProfit: 200.00,
    channelCommission: 40.00,        // 20% of gross profit
    netProfit: 160.00,

    reference: 'TKT-12345',
    openingBalance: 17000.00,
    closingBalance: 15750.00,
  },

  // Thaklis pays Service Partner
  {
    id: 'txn-003',
    date: moment().subtract(1, 'days').toISOString(),
    type: 'PARTNER_PAYMENT',
    subType: 'THAKLIS_TO_SERVICE_PARTNER',
    amount: 1050.00,
    currency: 'AED',
    status: 'COMPLETED',

    // Parties involved
    from: { id: 'thaklis', name: 'Thaklis', type: 'THAKLIS' },
    to: { id: 'partner-001', name: 'Emirates Services LLC', type: 'SERVICE_PARTNER' },

    // Ticket details
    ticketId: 'TKT-12345',
    ticketNumber: 'ORG-ABC-001',
    serviceName: 'Visa Renewal',

    reference: 'PAY-PARTNER-001',
    openingBalance: 45680.00,
    closingBalance: 44630.00,
  },

  // Thaklis pays Channel Partner Commission
  {
    id: 'txn-004',
    date: moment().subtract(1, 'days').toISOString(),
    type: 'COMMISSION_PAYMENT',
    subType: 'THAKLIS_TO_CHANNEL_PARTNER',
    amount: 40.00,
    currency: 'AED',
    status: 'COMPLETED',

    // Parties involved
    from: { id: 'thaklis', name: 'Thaklis', type: 'THAKLIS' },
    to: { id: 'cp-001', name: 'Elite Business Consultants', type: 'CHANNEL_PARTNER' },

    // Commission details
    ticketId: 'TKT-12345',
    ticketNumber: 'ORG-ABC-001',
    serviceName: 'Visa Renewal',
    grossProfit: 200.00,
    commissionRate: 20,               // 20%
    commissionType: 'PERCENTAGE',

    reference: 'COMM-001',
    openingBalance: 44630.00,
    closingBalance: 44590.00,
  },

  // Bank Transfer Topup
  {
    id: 'txn-005',
    date: moment().subtract(3, 'days').toISOString(),
    type: 'TOPUP',
    subType: 'BANK_TRANSFER',
    amount: 3000.00,
    currency: 'AED',
    status: 'COMPLETED',

    // Parties involved
    from: { id: 'cust-002', name: 'Tech Solutions LLC', type: 'CUSTOMER' },
    to: { id: 'thaklis', name: 'Thaklis', type: 'THAKLIS' },

    // Bank transfer details
    bankName: 'Emirates NBD',
    referenceNumber: 'REF123456789',
    bankAccountName: 'Thaklis - ENBD Main Account',
    approvedBy: 'Finance Admin',
    approvedAt: moment().subtract(3, 'days').add(1, 'hour').toISOString(),

    gatewayFee: 0,
    netAmount: 3000.00,

    openingBalance: 9000.00,
    closingBalance: 12000.00,
  },
];

// ========================================
// COMMISSION TRACKING
// ========================================

export const commissionEarnings = [
  {
    id: 'comm-001',
    channelPartnerId: 'cp-001',
    channelPartnerName: 'Elite Business Consultants',

    // Monthly summary
    month: moment().format('MMMM YYYY'),
    totalTickets: 8,
    totalGrossProfit: 1600.00,
    commissionRate: 20,
    totalCommission: 320.00,

    // Payment status
    status: 'PENDING',                 // PENDING, APPROVED, PAID
    approvedDate: null,
    paidDate: null,
    paymentReference: null,

    // Individual tickets that contributed
    tickets: [
      {
        ticketId: 'TKT-12345',
        ticketNumber: 'ORG-ABC-001',
        customerName: 'ABC Corporation',
        serviceName: 'Visa Renewal',
        completedDate: moment().subtract(5, 'days').toISOString(),
        grossProfit: 200.00,
        commission: 40.00,
      },
      {
        ticketId: 'TKT-12346',
        ticketNumber: 'ORG-ABC-002',
        customerName: 'ABC Corporation',
        serviceName: 'Trade License Renewal',
        completedDate: moment().subtract(4, 'days').toISOString(),
        grossProfit: 250.00,
        commission: 50.00,
      },
      {
        ticketId: 'TKT-12350',
        ticketNumber: 'ORG-XYZ-001',
        customerName: 'XYZ Enterprises',
        serviceName: 'New Visa Application',
        completedDate: moment().subtract(2, 'days').toISOString(),
        grossProfit: 180.00,
        commission: 36.00,
      },
    ],
  },

  {
    id: 'comm-002',
    channelPartnerId: 'cp-002',
    channelPartnerName: 'Gulf Marketing Agency',

    month: moment().format('MMMM YYYY'),
    totalTickets: 5,
    totalGrossProfit: 1250.00,
    commissionRate: 15,
    totalCommission: 187.50,

    status: 'PENDING',
    approvedDate: null,
    paidDate: null,
    paymentReference: null,

    tickets: [
      {
        ticketId: 'TKT-12360',
        ticketNumber: 'ORG-DEF-001',
        customerName: 'DEF Industries',
        serviceName: 'Emirates ID Renewal',
        completedDate: moment().subtract(6, 'days').toISOString(),
        grossProfit: 150.00,
        commission: 22.50,
      },
    ],
  },

  // Previous month - PAID
  {
    id: 'comm-003',
    channelPartnerId: 'cp-001',
    channelPartnerName: 'Elite Business Consultants',

    month: moment().subtract(1, 'month').format('MMMM YYYY'),
    totalTickets: 12,
    totalGrossProfit: 2400.00,
    commissionRate: 20,
    totalCommission: 480.00,

    status: 'PAID',
    approvedDate: moment().subtract(25, 'days').toISOString(),
    paidDate: moment().subtract(20, 'days').toISOString(),
    paymentReference: 'PAY-COMM-001',

    tickets: [],
  },
];

// ========================================
// SERVICE PARTNER PENDING PAYMENTS
// ========================================

export const pendingServicePartnerPayments = [
  {
    id: 'pending-001',
    partnerId: 'partner-001',
    partnerName: 'Emirates Services LLC',

    // Tickets pending payment
    tickets: [
      {
        ticketId: 'TKT-12400',
        ticketNumber: 'ORG-ABC-010',
        customerName: 'ABC Corporation',
        serviceName: 'Document Attestation',
        completedDate: moment().subtract(1, 'day').toISOString(),
        partnerCost: 450.00,
        status: 'UNPAID',
      },
      {
        ticketId: 'TKT-12401',
        ticketNumber: 'ORG-ABC-011',
        customerName: 'ABC Corporation',
        serviceName: 'Medical Fitness Test',
        completedDate: moment().subtract(2, 'days').toISOString(),
        partnerCost: 350.00,
        status: 'UNPAID',
      },
    ],

    totalAmount: 800.00,
    ticketCount: 2,
  },

  {
    id: 'pending-002',
    partnerId: 'partner-002',
    partnerName: 'Dubai Business Solutions',

    tickets: [
      {
        ticketId: 'TKT-12405',
        ticketNumber: 'ORG-XYZ-005',
        customerName: 'XYZ Enterprises',
        serviceName: 'Trade License Renewal',
        completedDate: moment().subtract(3, 'days').toISOString(),
        partnerCost: 1200.00,
        status: 'UNPAID',
      },
    ],

    totalAmount: 1200.00,
    ticketCount: 1,
  },
];

// ========================================
// PROFIT BY SERVICE TYPE
// ========================================

export const profitByService = [
  {
    serviceId: 'srv-001',
    serviceName: 'Visa Renewal',
    totalTickets: 45,
    totalRevenue: 56250.00,
    totalCosts: 47250.00,
    grossProfit: 9000.00,
    totalCommissions: 1800.00,
    netProfit: 7200.00,
    avgProfitPerTicket: 160.00,
  },
  {
    serviceId: 'srv-002',
    serviceName: 'New Visa Application',
    totalTickets: 32,
    totalRevenue: 48000.00,
    totalCosts: 40000.00,
    grossProfit: 8000.00,
    totalCommissions: 1600.00,
    netProfit: 6400.00,
    avgProfitPerTicket: 200.00,
  },
  {
    serviceId: 'srv-003',
    serviceName: 'Trade License Renewal',
    totalTickets: 28,
    totalRevenue: 42000.00,
    totalCosts: 35000.00,
    grossProfit: 7000.00,
    totalCommissions: 1400.00,
    netProfit: 5600.00,
    avgProfitPerTicket: 200.00,
  },
  {
    serviceId: 'srv-004',
    serviceName: 'Emirates ID Renewal',
    totalTickets: 56,
    totalRevenue: 28000.00,
    totalCosts: 23800.00,
    grossProfit: 4200.00,
    totalCommissions: 840.00,
    netProfit: 3360.00,
    avgProfitPerTicket: 60.00,
  },
];

// ========================================
// PROFIT BY CUSTOMER
// ========================================

export const profitByCustomer = [
  {
    customerId: 'cust-001',
    customerName: 'ABC Corporation',
    totalTickets: 25,
    totalRevenue: 31250.00,
    grossProfit: 6250.00,
    netProfit: 5000.00,
    channelPartner: 'Elite Business Consultants',
    commissionsPaid: 1250.00,
  },
  {
    customerId: 'cust-002',
    customerName: 'Tech Solutions LLC',
    totalTickets: 18,
    totalRevenue: 22500.00,
    grossProfit: 4500.00,
    netProfit: 3600.00,
    channelPartner: 'Elite Business Consultants',
    commissionsPaid: 900.00,
  },
  {
    customerId: 'cust-003',
    customerName: 'XYZ Enterprises',
    totalTickets: 22,
    totalRevenue: 27500.00,
    grossProfit: 5500.00,
    netProfit: 4675.00,
    channelPartner: 'Gulf Marketing Agency',
    commissionsPaid: 825.00,
  },
  {
    customerId: 'cust-004',
    customerName: 'Global Industries',
    totalTickets: 15,
    totalRevenue: 18750.00,
    grossProfit: 3750.00,
    netProfit: 3000.00,
    channelPartner: null,               // Direct customer, no channel partner
    commissionsPaid: 0,
  },
];

// ========================================
// PAYMENT GATEWAY COST ANALYSIS
// ========================================

export const gatewayAnalysis = [
  {
    gatewayName: 'Stripe',
    totalTransactions: 145,
    totalVolume: 725000.00,
    totalFees: 21145.00,
    avgFeePercentage: 2.92,
    usage: 'PRIMARY',
  },
  {
    gatewayName: 'Tabby',
    totalTransactions: 87,
    totalVolume: 435000.00,
    totalFees: 13050.00,
    avgFeePercentage: 3.0,
    usage: 'ALTERNATIVE',
  },
  {
    gatewayName: 'Bank Transfer',
    totalTransactions: 34,
    totalVolume: 340000.00,
    totalFees: 0,
    avgFeePercentage: 0,
    usage: 'BULK_PAYMENTS',
  },
];

// ========================================
// SERVICE PROFITABILITY TRENDS (6 Months)
// ========================================

export const serviceProfitabilityTrends = [
  {
    month: moment().subtract(5, 'months').format('MMM YYYY'),
    services: [
      { serviceName: 'Visa Renewal', revenue: 48000, grossProfit: 7680, tickets: 38 },
      { serviceName: 'New Visa Application', revenue: 38000, grossProfit: 6080, tickets: 25 },
      { serviceName: 'Trade License Renewal', revenue: 35000, grossProfit: 5600, tickets: 23 },
      { serviceName: 'Emirates ID Renewal', revenue: 24000, grossProfit: 3360, tickets: 48 },
    ],
  },
  {
    month: moment().subtract(4, 'months').format('MMM YYYY'),
    services: [
      { serviceName: 'Visa Renewal', revenue: 50000, grossProfit: 8000, tickets: 40 },
      { serviceName: 'New Visa Application', revenue: 40000, grossProfit: 6400, tickets: 27 },
      { serviceName: 'Trade License Renewal', revenue: 37000, grossProfit: 5920, tickets: 25 },
      { serviceName: 'Emirates ID Renewal', revenue: 25000, grossProfit: 3500, tickets: 50 },
    ],
  },
  {
    month: moment().subtract(3, 'months').format('MMM YYYY'),
    services: [
      { serviceName: 'Visa Renewal', revenue: 52000, grossProfit: 8320, tickets: 42 },
      { serviceName: 'New Visa Application', revenue: 42000, grossProfit: 6720, tickets: 28 },
      { serviceName: 'Trade License Renewal', revenue: 39000, grossProfit: 6240, tickets: 26 },
      { serviceName: 'Emirates ID Renewal', revenue: 26000, grossProfit: 3640, tickets: 52 },
    ],
  },
  {
    month: moment().subtract(2, 'months').format('MMM YYYY'),
    services: [
      { serviceName: 'Visa Renewal', revenue: 54000, grossProfit: 8640, tickets: 43 },
      { serviceName: 'New Visa Application', revenue: 44000, grossProfit: 7040, tickets: 29 },
      { serviceName: 'Trade License Renewal', revenue: 40000, grossProfit: 6400, tickets: 27 },
      { serviceName: 'Emirates ID Renewal', revenue: 27000, grossProfit: 3780, tickets: 54 },
    ],
  },
  {
    month: moment().subtract(1, 'month').format('MMM YYYY'),
    services: [
      { serviceName: 'Visa Renewal', revenue: 55000, grossProfit: 8800, tickets: 44 },
      { serviceName: 'New Visa Application', revenue: 46000, grossProfit: 7360, tickets: 31 },
      { serviceName: 'Trade License Renewal', revenue: 41000, grossProfit: 6560, tickets: 27 },
      { serviceName: 'Emirates ID Renewal', revenue: 27500, grossProfit: 3850, tickets: 55 },
    ],
  },
  {
    month: moment().format('MMM YYYY'),
    services: [
      { serviceName: 'Visa Renewal', revenue: 56250, grossProfit: 9000, tickets: 45 },
      { serviceName: 'New Visa Application', revenue: 48000, grossProfit: 8000, tickets: 32 },
      { serviceName: 'Trade License Renewal', revenue: 42000, grossProfit: 7000, tickets: 28 },
      { serviceName: 'Emirates ID Renewal', revenue: 28000, grossProfit: 4200, tickets: 56 },
    ],
  },
];

// ========================================
// TOP PERFORMING SERVICES (Current Month)
// ========================================

export const topPerformingServices = [
  {
    serviceName: 'Visa Renewal',
    rank: 1,
    totalTickets: 45,
    totalRevenue: 56250.00,
    grossProfit: 9000.00,
    profitMargin: 16.0,
    avgTicketValue: 1250.00,
    growth: 2.3,  // % growth vs last month
  },
  {
    serviceName: 'New Visa Application',
    rank: 2,
    totalTickets: 32,
    totalRevenue: 48000.00,
    grossProfit: 8000.00,
    profitMargin: 16.7,
    avgTicketValue: 1500.00,
    growth: 4.3,
  },
  {
    serviceName: 'Trade License Renewal',
    rank: 3,
    totalTickets: 28,
    totalRevenue: 42000.00,
    grossProfit: 7000.00,
    profitMargin: 16.7,
    avgTicketValue: 1500.00,
    growth: 2.4,
  },
  {
    serviceName: 'Emirates ID Renewal',
    rank: 4,
    totalTickets: 56,
    totalRevenue: 28000.00,
    grossProfit: 4200.00,
    profitMargin: 15.0,
    avgTicketValue: 500.00,
    growth: 1.8,
  },
  {
    serviceName: 'Document Attestation',
    rank: 5,
    totalTickets: 18,
    totalRevenue: 9000.00,
    grossProfit: 1800.00,
    profitMargin: 20.0,
    avgTicketValue: 500.00,
    growth: -2.5,  // Negative growth
  },
];

// ========================================
// PAYMENT METHOD DISTRIBUTION
// ========================================

export const paymentMethodDistribution = [
  {
    method: 'Stripe (Credit/Debit Card)',
    category: 'ONLINE',
    totalTransactions: 145,
    totalAmount: 725000.00,
    percentage: 48.3,
    avgTransactionValue: 5000.00,
    fees: 21145.00,
    netAmount: 703855.00,
  },
  {
    method: 'Tabby (Buy Now Pay Later)',
    category: 'ONLINE',
    totalTransactions: 87,
    totalAmount: 435000.00,
    percentage: 29.0,
    avgTransactionValue: 5000.00,
    fees: 13050.00,
    netAmount: 421950.00,
  },
  {
    method: 'Bank Transfer (Online)',
    category: 'ONLINE',
    totalTransactions: 56,
    totalAmount: 180000.00,
    percentage: 12.0,
    avgTransactionValue: 3214.29,
    fees: 0,
    netAmount: 180000.00,
  },
  {
    method: 'Bank Transfer (Offline)',
    category: 'OFFLINE',
    totalTransactions: 34,
    totalAmount: 160000.00,
    percentage: 10.7,
    avgTransactionValue: 4705.88,
    fees: 0,
    netAmount: 160000.00,
  },
];

// ========================================
// HELPER FUNCTIONS
// ========================================

export const getFinancialSummary = () => thaklisFinanceOverview;

export const getTransactionsByType = (type) => {
  if (!type) return detailedTransactions;
  return detailedTransactions.filter(txn => txn.type === type);
};

export const getPendingCommissions = () => {
  return commissionEarnings.filter(comm => comm.status === 'PENDING');
};

export const getTotalPendingCommissions = () => {
  return getPendingCommissions().reduce((sum, comm) => sum + comm.totalCommission, 0);
};

export const getPendingServicePayments = () => pendingServicePartnerPayments;

export const getTotalPendingServicePayments = () => {
  return pendingServicePartnerPayments.reduce((sum, payment) => sum + payment.totalAmount, 0);
};
